export const modules = {
  toolbar: [[{ list: 'bullet' }]],
};
